module.exports = __webpack_public_path__ + "static/img/5.43bce6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/5.png
// module id = cUaQ
// module chunks = 0